import CompanyRatings from '../components/reports/ratings/CompanyRatings';
import Discounts from '../components/reports/Discounts';
import MoverTotals from '../components/reports/MoverTotals';
import Ratings from '../components/reports/ratings/Ratings';
import Totals from '../components/reports/Totals';
import SalesTotals from '../components/reports/SalesTotals';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/reports',
  component: Template,
  children: [
    {
      path: 'ratings/:id',
      name: 'CompanyRatings',
      component: CompanyRatings,
      meta: {
        title: 'Company Ratings - Mod24',
      },
    },
    {
      path: 'discounts',
      name: 'Discounts',
      component: Discounts,
      meta: {
        title: 'Discounts - Mod24',
      },
    },
    {
      path: 'mover-totals',
      name: 'Mover Totals',
      component: MoverTotals,
      meta: {
        title: 'Mover Totals - Mod24',
      },
    },
    {
      path: 'ratings',
      name: 'Ratings',
      component: Ratings,
      meta: {
        title: 'Ratings - Mod24',
      },
    },
    {
      path: 'sales',
      name: 'SalesTotals',
      component: SalesTotals,
      meta: {
        title: 'Sales Totals - Mod24',
      },
    },
    {
      path: 'totals',
      name: 'Totals',
      component: Totals,
      meta: {
        title: 'Totals - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/reportsRoutes.js